import { List as MuiList, ListProps, ListSubheader, SxProps } from '@mui/material';
import { FC } from 'react';

const List: FC<ListProps & { subheaderSx?: SxProps }> = (props) => {
  return props.subheader ? (
    <MuiList
      {...props}
      subheader={
        <ListSubheader
          sx={{
            lineHeight: 'unset',
            pt: 1,
            ...props.subheaderSx
          }}
        >
          {props.subheader}
        </ListSubheader>
      }
    />
  ) : (
    <MuiList {...props} />
  );
};

export default List;
